import React from "react";
import "./StockistDetails.css";
import { useEffect, useState } from "react";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { ReactSession } from "react-client-session";

const StockistDetails = ({partyInfo}) => {
  // const axiosPrivate = useAxiosPrivate();


  return (
    <div className="stockist-details-container">
      <section className="stockist-details-container-section">
        <h4 className="stockist-details-container-heading">PO NO:</h4>
        <span className="stockist-details-container-details">
          {partyInfo.po_no}
        </span>
      </section>
      <section className="stockist-details-container-section">
        <h4 className="stockist-details-container-heading">PARTY CODE:</h4>
        <span className="stockist-details-container-details">
          {" "}
          {partyInfo.party_code}
        </span>
      </section>
      <section className="stockist-details-container-section">
        <h4 className="stockist-details-container-heading">PARTY NAME:</h4>
        <span className="stockist-details-container-details">
          {partyInfo.party_name}
        </span>
      </section>
    </div>
  );
};

export default StockistDetails;
